import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  Filter,
  Users,
  Building2,
  Kanban,
  BarChart3,
  Target,
  Settings,
  UserPlus,
  ChevronLeft,
  ChevronRight,
} from 'lucide-react'
import styles from './Sidebar.module.css'

interface SidebarProps {
  collapsed: boolean
  onToggle: () => void
}

interface MenuItem {
  path: string
  icon: typeof LayoutDashboard
  label: string
}

interface MenuSection {
  title: string
  items: MenuItem[]
}

const menuSections: MenuSection[] = [
  {
    title: 'Principal',
    items: [
      { path: '/', icon: LayoutDashboard, label: 'Overview' },
      { path: '/funil', icon: Filter, label: 'Funil de Vendas' },
    ],
  },
  {
    title: 'Performance',
    items: [
      { path: '/corretores', icon: Users, label: 'Corretores' },
      { path: '/empreendimentos', icon: Building2, label: 'Empreendimentos' },
    ],
  },
  {
    title: 'Operacional',
    items: [
      { path: '/leads', icon: Kanban, label: 'Leads / Kanban' },
      { path: '/produtividade', icon: BarChart3, label: 'Produtividade' },
      { path: '/metas', icon: Target, label: 'Metas' },
      { path: '/cadastro-colaboradores', icon: UserPlus, label: 'Cadastro Colaboradores' },
    ],
  },
  {
    title: 'Integrado',
    items: [
      { path: '/intersetorial', icon: Settings, label: 'Intersetorial' },
    ],
  },
]

export function Sidebar({ collapsed, onToggle }: SidebarProps) {
  return (
    <aside className={`${styles.sidebar} ${collapsed ? styles.collapsed : ''}`}>
      {/* Logo */}
      <div className={styles.logo}>
        {!collapsed && (
          <>
            <div className={styles.logoIcon}>FAJ</div>
            <span className={styles.logoText}>Dashboard Comercial</span>
          </>
        )}
        {collapsed && <div className={styles.logoIcon}>FAJ</div>}
      </div>

      {/* Navigation */}
      <nav className={styles.nav}>
        {menuSections.map((section) => (
          <div key={section.title} className={styles.menuSection}>
            {!collapsed && <span className={styles.sectionTitle}>{section.title}</span>}
            <ul className={styles.menu}>
              {section.items.map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `${styles.menuItem} ${isActive ? styles.active : ''}`
                    }
                  >
                    <item.icon className={styles.menuIcon} size={20} />
                    {!collapsed && <span className={styles.menuLabel}>{item.label}</span>}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>

      {/* Toggle Button */}
      <button className={styles.toggleButton} onClick={onToggle} aria-label="Toggle sidebar">
        {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
      </button>
    </aside>
  )
}
